export const noBuyReasonsEn = {
  NO_BUY_REASONS: 'No Buy Reasons',
  NO_BUY_REASON: 'No Buy Reason',
  NO_BUY_NOTE: 'No Buy Note',
  NO_BUY_REASONS_DESCRIPTION: 'Manage the reasons available when a Client, Broker or Debtor is marked as No Buy.',
  CREATE_NO_BUY_REASON: 'Create No Buy Reason',
  UPDATE_NO_BUY_REASON: 'Update No Buy Reason',
  NO_BUY_REASON_NAME_PLACEHOLDER: 'e.g. Bankruptcy, Slow Pay, Credit Hold',
  DELETE_NO_BUY_REASON: 'Delete No Buy Reason',
  DELETE_NO_BUY_REASON_CONFIRMATION:
    'Are you sure you want to delete this No Buy reason? It will no longer be selectable, and once deleted it cannot be restored.',
  NO_BUY_REASON_CREATED_SUCCESSFULLY: 'No Buy reason created successfully',
  NO_BUY_REASON_UPDATED_SUCCESSFULLY: 'No Buy reason updated successfully',
  NO_BUY_REASON_DEACTIVATED_SUCCESSFULLY: 'No Buy reason deactivated successfully',
  NO_BUY_REASON_REQUIRED_FIELD: 'A No Buy reason is required',
  NO_BUY_REASON_INACTIVE_OPTION: '{reasonName} (Inactive)',
}

export const noBuyReasonsEs: typeof noBuyReasonsEn = {
  NO_BUY_REASONS: 'Razones de No Buy',
  NO_BUY_REASON: 'Razón de No Buy',
  NO_BUY_NOTE: 'Nota de No Buy',
  NO_BUY_REASONS_DESCRIPTION: 'Gestiona las razones disponibles al marcar un Client, Broker o Debtor como No Buy.',
  CREATE_NO_BUY_REASON: 'Crear Razón de No Buy',
  UPDATE_NO_BUY_REASON: 'Actualizar Razón de No Buy',
  NO_BUY_REASON_NAME_PLACEHOLDER: 'ej. Bancarrota, Pago Lento, Bloqueo de Crédito',
  DELETE_NO_BUY_REASON: 'Eliminar Razón de No Buy',
  DELETE_NO_BUY_REASON_CONFIRMATION:
    '¿Estás seguro de que deseas eliminar esta razón de No Buy? Ya no se podrá seleccionar, y una vez eliminada no se puede restaurar.',
  NO_BUY_REASON_CREATED_SUCCESSFULLY: 'Razón de No Buy creada con éxito',
  NO_BUY_REASON_UPDATED_SUCCESSFULLY: 'Razón de No Buy actualizada con éxito',
  NO_BUY_REASON_DEACTIVATED_SUCCESSFULLY: 'Razón de No Buy desactivada con éxito',
  NO_BUY_REASON_REQUIRED_FIELD: 'Se requiere una razón de No Buy',
  NO_BUY_REASON_INACTIVE_OPTION: '{reasonName} (Inactiva)',
}
